import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { BaseSubsectionAdapter } from '../../../adapters/BaseSubsectionAdapter'
import { RecertFormData } from '../../types/RecertFormData'
import { RecertAssessmentQuestionnaireItem } from '../../types/questionnaire'
import { RecertFormField } from '../../types/RecertFormField'

export class AuthorizationAdapter extends BaseSubsectionAdapter<RecertFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<RecertFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    const authorizationSource = getAnswerValuesFromItems(
      flatAnswersArray,
      RecertAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE
    ).at(0)

    const currentHours = getAnswerValuesFromItems(
      flatAnswersArray,
      RecertAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_CURRENT_HOURS
    ).at(0)

    return {
      [RecertFormField.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE]: Array.isArray(
        authorizationSource
      )
        ? authorizationSource?.map((source) => source.reference)
        : authorizationSource?.reference,
      [RecertFormField.AUTHORIZATION_CURRENT_HOURS]: currentHours
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (
      this.formDataFieldExists(RecertFormField.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE)
    ) {
      const authorizationSource = this.getFormDataField(
        RecertFormField.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE
      )

      mutations.push({
        linkId: RecertAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE,
        value: Array.isArray(authorizationSource)
          ? authorizationSource?.map((source) => (source ? { reference: source } : undefined))
          : authorizationSource
          ? { reference: authorizationSource }
          : undefined
      })
    }

    if (this.formDataFieldExists(RecertFormField.AUTHORIZATION_CURRENT_HOURS)) {
      const currentHours = this.getFormDataField(RecertFormField.AUTHORIZATION_CURRENT_HOURS)

      mutations.push({
        linkId: RecertAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_CURRENT_HOURS,
        value: currentHours
      })
    }

    return mutations
  }
}
